import { StatusType } from './status-types'

export const makeStatusInitialState = () => ({
  status: StatusType.IDLE,
  error: null,
})
